import * as React from "react";
import { Button, type ButtonProps } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

export interface SubmitButtonProps extends ButtonProps {
    loading: boolean;
    label: string;
    loadingLabel?: string;
    icon?: React.ReactNode;
}

export const SubmitButton = React.forwardRef<HTMLButtonElement, SubmitButtonProps>(
    ({ loading, label, loadingLabel = "Creating...", disabled, icon, children, ...props }, ref) => {
        return (
            <Button
                ref={ref}
                disabled={loading || disabled}
                aria-busy={loading}
                aria-live="polite"
                {...props}
            >
                {loading ? (
                    <>
                        <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
                        {loadingLabel}
                    </>
                ) : (
                    <>
                        {icon && <span className="mr-2">{icon}</span>}
                        {children || label}
                    </>
                )}
            </Button>
        );
    }
);
SubmitButton.displayName = "SubmitButton";
